import { useSyncExternalStore } from 'react';

let hasNewVersion = false;
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

export function markNewVersion() {
    if (hasNewVersion) return;
    hasNewVersion = true;
    for (const listener of listeners) listener();
}

export const useHasNewVersion = () => useSyncExternalStore(subscribe, () => hasNewVersion);
